import Container from 'react-bootstrap/Container'
import Typography from '../../Typography/Typography'

import './FormLine.scss'

const FormLine = ({ text, color = 'blue' }) => {
    const lineColor = color === 'blue' ? 'bg-lighterPrimary' : 'bg-white opacity-50'

    return (
        <Container fluid className={'d-flex'}>
            <div className={`w-100 form-line mt-auto ${lineColor}`} />
            <Typography variant={'formLabel'} className={'text-nowrap mx-3'}>
                {text}
            </Typography>
            <div className={`w-100 form-line mt-auto ${lineColor}`} />
        </Container>
    )
}

export default FormLine
